import React from "react";

export default function Table({ children }) {
  return (
    <div className="shadow border-b border-gray-200 sm:rounded-lg">
      <table className="min-w-full divide-y divide-gray-200">{children}</table>
    </div>
  );
}
